import { IAction, StateStatus } from 'redux/utils/common';
import * as Types from './types';
import { IFavoritesData, IClientCollectionsData } from 'services/api/client';
import * as ProductService from 'services/api/product';
import { IListAssignClientsOutput } from 'services/api/product';

export interface IState {
  clientCollectionsAgent: {
    status: StateStatus | null;
    data: IClientCollectionsData | null;
  };
  clientCollectionsPersonal: {
    status: StateStatus | null;
    data: IClientCollectionsData | null;
  };
  deleteClientCollection: {
    status: StateStatus | null;
  };
  customers: {
    data: Array<ProductService.IMiniProfile>;
    status: StateStatus | null;
  };
  shareCollection: {
    status: StateStatus | null;
  };
  favouriteProducts: {
    data: Array<IFavoritesData['items']>;
    status: StateStatus | null;
  };
  assignClientsCollections: {
    data: IListAssignClientsOutput['data'];
    status: StateStatus | null;
  };
  addAssignClients: {
    status: StateStatus | null;
  };
}

const initialState: IState = {
  clientCollectionsPersonal: {
    status: null,
    data: null,
  },
  clientCollectionsAgent: {
    status: null,
    data: null,
  },
  deleteClientCollection: {
    status: null,
  },
  customers: {
    data: [],
    status: null,
  },
  shareCollection: {
    status: null,
  },
  favouriteProducts: {
    data: [],
    status: null,
  },
  assignClientsCollections: {
    data: [],
    status: null,
  },
  addAssignClients: {
    status: null,
  },
};

const ClientCollectionReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_CLIENT_COLLECTION_AGENT:
      return {
        ...state,
        clientCollectionsAgent: {
          ...state.clientCollectionsAgent,
          status: action.status ?? null,
          data: action.data,
        },
      };
    case Types.SET_CLIENT_COLLECTION_PERSONAL:
      return {
        ...state,
        clientCollectionsPersonal: {
          ...state.clientCollectionsPersonal,
          status: action.status ?? null,
          data: action.data,
        },
      };
    case Types.DELETE_CLIENT_COLLECTION:
      return {
        ...state,
        deleteClientCollection: {
          ...state.deleteClientCollection,
          status: action.status ?? null,
        },
      };

    case Types.SET_CUSTOMERS:
      return {
        ...state,
        customers: {
          ...state.customers,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.CLIENT_SHARE_COLLECTIONS:
      return {
        ...state,
        shareCollection: {
          ...state.shareCollection,
          status: action.status || null,
        },
      };
    case Types.SET_CLIENT_FAVOURITE_PRODUCTS:
      return {
        ...state,
        favouriteProducts: {
          ...state.favouriteProducts,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_ASSIGN_CLIENTS_PRODUCTS:
      return {
        ...state,
        assignClientsCollections: {
          ...state.assignClientsCollections,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_ADD_ASSIGN_CLIENTS:
      return {
        ...state,
        addAssignClients: {
          ...state.addAssignClients,
          status: action.status || null,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default ClientCollectionReducer;
